module.exports = __webpack_public_path__ + "static/assets/c2e1648403434547d1724a3453c74d74.png";